<!-- 一般ユーザー　予約情報詳細-->
<style src="@/assets/css/common_parts_input.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_course.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_price.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_reservation.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_mypage.css" type="text/css" media="all" scoped></style>


<style scoped>

</style>
<template>
  <div class="container" id="reserveDetail">
    <div class="contents">
			<h2>予約情報詳細</h2>
      <!-- ▽  -->
      <section id="mainContents">
        <section class="confirmArea">
          <!-- 予約情報 -->
          <section class="reservation">
            <h3 class="ukNo"><span>予約番号</span>{{detail.ukno}}</h3>
            <ul class="date">
              <li>{{detail.reserveDateYear}}<!--年--></li>
              <li>{{detail.reserveDateMonth}}<!--月--></li>
              <li>{{detail.reserveDateDate}}<!--日--></li>
              <li>{{detail.reserveSthm}}<!--時間--></li>
            </ul>
            <!-- 選択コース詳細 -->
            <div class="course">
              <h4>{{detail.courseInfo.ksnm}}</h4>
              <dl class="item">
                <dt>検査項目</dt>
                <dd>
                  <ul>
                    <li v-for="item in detail.courseInfo.listInspection" v-bind:key="item.kmnm" v-bind:class="getBackendColorInspectionJskb(item.jskb)">
                      <span>{{item.kmnm}}</span>
                    </li>
                  </ul>
                </dd>
              </dl>
              <div class="fBox">
                <div class="plan">
                  <p class="time"><span>所要時間</span>{{detail.courseInfo.time}}</p>
                  <p class="note">
                    {{detail.courseInfo.mem1}}
                  </p>
                  <dl class="target">
								    <dt>この検査を受けて欲しい方</dt>
								    <dd>{{detail.courseInfo.mem2}}</dd>
                  </dl>
                  <dl class="option">
								    <dt>追加オプション</dt>
								    <dd>
                      <ul>
                        <li v-for="item in detail.optionInfoList" v-bind:key="item.opnm">
                          {{item.opnm}}
                        </li>
                      </ul>
                    </dd>
                  </dl>
                </div>
                <!-- 料金明細 -->
                <div class="price">
                  <h4>料金明細</h4>
                  <p class="base">
                    {{detail.courseInfo.ksnm}}
                    <div v-if="detail.kshj=='1'">
                      <em>
                        {{detail.courseInfo.gkgk | moneyDelimiter}}
                        <span v-if="detail.taxk=='1'">（税抜）</span>
                        <span v-else>（税込）</span>
                      </em>
                    </div>
                  </p>
                  <ul>
                    <li v-for="item in detail.optionInfoList" v-bind:key="item.opnm">
                      {{item.opnm}}
                      <div v-if="detail.kshj=='1'">
                        <em>
                          {{item.gkgk | moneyDelimiter}}
                          <span v-if="detail.taxk=='1'">（税抜）</span>
                          <span v-else>（税込）</span>
                        </em>
                      </div>
                    </li>
                  </ul>
                  <p class="total">
                    合計金額
                    <b>
                      {{detail.sumGkgk | moneyDelimiter}}
                      <span v-if="detail.taxk=='1'">（税抜）</span>
                      <span v-else>（税込）</span>
                    </b>
                  </p>
                </div>
              </div>
            </div>
          </section>
          <!-- 個人情報 -->
          <section class="personalDataTbl">
			      <dl v-if="detail.jgcdIsDisplay">
              <dt>健康保険組合名</dt>
			      	<dd>{{detail.jgnm}}</dd>
			      </dl>
			      <dl v-if="detail.hkshIsDisplay">
              <dt>保険者番号</dt>
			      	<dd>{{detail.hksh}}</dd>
			      </dl>
            <dl v-if="detail.hkkgIsDisplay">
              <dt>保険証記号</dt>
              <dd>{{detail.hkkg}}</dd>
            </dl>
            <dl v-if="detail.hknoIsDisplay">
              <dt>保険証番号</dt>
              <dd>{{detail.hkno}}</dd>
            </dl>
				    <dl v-if="detail.hfkbIsDisplay">
              <dt>対象者区分</dt>
				    	<dd>{{this.detail.kbnm}}</dd>
				    </dl>
				    <dl v-if="detail.cmnmIsDisplay">
              <dt>企業名</dt>
				    	<dd>{{this.detail.cmnm}}</dd>
				    </dl>
            <dl class="nameOutput" v-if="(detail.ryk1IsDisplay&&detail.ryk2IsDisplay) || (detail.nam1IsDisplay&&detail.nam2IsDisplay)">
              <dt>氏名</dt>
              <dd class="indiscrete">
                <ul>
                  <!-- 氏名（カタカナ） -->
                  <li v-if="detail.ryk1IsDisplay&&detail.ryk2IsDisplay">{{this.detail.ryak}}</li>
                  <!-- 氏名（漢字） -->
                  <li v-if="detail.nam1IsDisplay&&detail.nam2IsDisplay">{{this.detail.name}}</li>
                </ul>
              </dd>
            </dl>
					  <dl class="birthday" v-if="detail.btdyYearIsDisplay&&detail.btdyMonthIsDisplay&&detail.btdyDateIsDisplay">
    	        <dt>生年月日</dt>
					  	<dd><ul><li>{{this.detail.btdyYear}}</li><li>{{this.detail.btdyMonth}}</li><li>{{this.detail.btdyDate}}</li></ul></dd>
					  </dl>
					  <dl class="age" v-if="detail.ageIsDisplay">
    	        <dt>年齢</dt>
					  	<dd><span>受診日時点での年度年齢</span><b>{{this.detail.age}}</b></dd>
					  </dl>
				    <dl v-if="detail.sexIsDisplay">
              <dt>性別</dt>
				    	<dd>
                {{computedStrSex}}
              </dd>
				    </dl>
				    <dl class="add" v-if="detail.zip1IsDisplay&&detail.zip2IsDisplay&&detail.adr1IsDisplay&&detail.adr2IsDisplay">
              <dt>ご住所</dt>
				    	<dd>
				    		<ul>
				    			<li class="zip">{{detail.zip}}</li>
				    			<li>{{computedStrAddr}}</li>
				    		</ul>
				    	</dd>
				    </dl>
				    <dl v-if="detail.tel1IsDisplay">
              <dt>電話番号</dt>
				    	<dd>
				    		<ul>
				    			<li class="tel">{{this.detail.tel1}}</li>
				    		</ul>
				    	</dd>
				    </dl>
            <dl v-if="detail.synoIsDisplay">
              <dt>社員番号</dt>
              <dd>{{this.detail.syno}}</dd>
            </dl>
            <dl v-if="detail.dmkbIsDisplay">
              <dt>ＤＭ・メルマガ</dt>
              <dd>{{computedStrDmkb}}</dd>
            </dl>
				    <dl v-if="detail.mem1IsDisplay">
              <dt>備考</dt>
				    	<dd>{{this.detail.mem1}}</dd>
				    </dl>
          </section>
          <div class="btnLst"><button class="backBtn" v-on:click="onBack">戻る</button></div>
        </section>
      </section>
      <!-- △ mainContents END -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
        <dt slot="modal-header">システムエラー</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
    </div>
  </div>
</template>
<script>
  import { CommonReserveDetail } from '@/api'
  import * as types from '@/store/mutation-types'
  import * as ErrorCodes from '@/components/Utility/error-codes'
  import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
  import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    // モジュール名
    name: 'CommonReserveDetail',
		// 使用コンポーネント
		components: {
			// エラー表示コンポーネント
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ表示コンポーネント
			modalWindow: ModalWindow
		},
		// フィルター
		filters: {
			// 金額表示用三桁ごとにカンマをつける
			moneyDelimiter: function(value) {

				if(value == null) {
					return ''
				}
				
				return value.toLocaleString()
			}
		},
		// 算出プロパティ
		computed: {
		  // 性別 表示用文字列を取得
      computedStrSex: function() {

        var result = ''
        
        if(this.detail.codeSexMan == this.detail.sex) {
          result = '男性'
        } else if(this.detail.codeSexWoman == this.detail.sex) {
          result = '女性'
        }

        return result
      },
      // 住所 表示用文字列を取得
      computedStrAddr: function() {
        
        var result = ''

        if('' == this.detail.adr1 || '' == this.detail.adr2 ){
          return result
        }

        result = this.detail.adr1 + this.detail.adr2
        
        if('' != this.detail.adr3 && this.detail.adr3IsDisplay){
          result += this.detail.adr3
        }

        return result
      },
      // ＤＭ・メルマガ 表示用文字列を取得
      computedStrDmkb: function() {
        
        var result = ''

        if(this.detail.codeDmkbNG == this.detail.dmkb) {
          result = '受け取らない'
        } else if(this.detail.codeDmkbOK == this.detail.dmkb) {
          result = '受け取る'
        }

        return result
      },
		},
    // データ
    data() {
      return {
				// ユーザータイプ
        userType: '2',
				// 予約確認画面と同じロジックで実装
				// 2: マイページ経由かつ予約変更（個人）
        codeUserTypeMyPageChangeIndividual: '2',
        // 3: マイページ経由かつ予約変更（健保）
        codeUserTypeMyPageChangeHealth: '3',

        // 表示項目
        detail: {

          // 消費税区分
          // 1: 外税 税抜
          // 2: 内税 税込
          taxk: '',

          // 金額表示
          // 0:非表示 1:表示
          kshj: '',

					// 予約受付番号
					ukno: '',

          // 予約日付
          // 年
          reserveDateYear: 0,
          // 月
          reserveDateMonth: 0,
          // 日
          reserveDateDate: 0,
          // 予約時間帯　開始時間表示名
          reserveSthm: '',

          // コース情報
          // ksnm コース名
          // time 経過時間
          // kngk 金額
          // gkgk 消費税込み金額
          // listInspection: 検査項目リスト
          //  kmnm: 検査項目名
          //  jskb: 受診区分
          courseInfo: {
            ksnm: '',
            time: '',
            mem1: '',
            mem2: '',
            gkgk: 0,
            listInspection: [
              {
                ksnm: '',
                jskb: ''
              }
            ]
          },

          // gkgk: 合計金額
          optionInfoList: [],
          // 合計金額
          //sumKngk: 0,
          // 合計消費税込み金額
          sumGkgk: 0,

          // 健康保険組合名（クライアント名）
          jgnm: '',
          // 保険者番号
          hksh: '',
          // 保険証記号
          hkkg: '',
          // 保険証番号
          hkno: '',
          // 対象者区分名
          kbnm: '',
          // 企業名
          cmnm: '',
          // 漢字氏名
          name: '',
          // カナ氏名
          ryak: '',
          // 生年月日　年
          btdyYear: 0,
          // 生年月日　月
          btdyMonth: 0,
          // 生年月日　日付
          btdyDate: 0,
          // 年齢
          age: 0,
          // 性別の選択値 1:男、2:女
          sex: '',
          // 性別 男のコード値
          codeSexMan: '1',
          // 性別 女のコード値
          codeSexWoman: '2',
          // ご住所
          // 郵便番号
          zip: '',
          // 都道府県
          adr1: '',
          // 住所１（市区町村）
          adr2: '',
          // 住所２（番地）
          adr3: '',
          // 電話番号（日中連絡先）
          tel1: '',
          // 社員番号
          syno: '',
          // メールアドレス
          email: '',
          // ＤＭ・メルマガ 0:受け取らない、1:受け取る
          dmkb: '',
          // ＤＭ・メルマガ 受け取らないのコード値
          codeDmkbNG: '0',
          // ＤＭ・メルマガ 受け取るのコード値
          codeDmkbOK: '1',
          // 備考
          mem1: '',

          // 健康保険組合名
          // 表示非表示フラグ
          jgcdIsDisplay: false,
          // 保険者番号
          hkshIsDisplay: false,
          // 保険証記号
          hkkgIsDisplay: false,
          // 保険証番号
          hknoIsDisplay: false,
          // 対象者区分
          hfkbIsDisplay: false,
          // 企業名
          cmnmIsDisplay: false,
          // 漢字氏名
          // 姓
          nam1IsDisplay: false,
          // 名
          nam2IsDisplay: false,
          // カナ氏名
          // 姓
          ryk1IsDisplay: false,
          // 名
          ryk2IsDisplay: false,
          // 生年月日
          // 年
          btdyYearIsDisplay: false,
          // 月
          btdyMonthIsDisplay: false,
          // 日
          btdyDateIsDisplay: false,
          // 年齢
          ageIsDisplay: false,
          // 性別
          sexIsDisplay: false,
          // ご住所
          // 郵便番号 前半
          zip1IsDisplay: false,
          // 郵便番号 後半
          zip2IsDisplay: false,
          // 都道府県
          adr1IsDisplay: false,
          // 住所１（市区町村）
          adr2IsDisplay: false,
          // 住所２（番地）
          adr3IsDisplay: false,
					// 電話番号
          tel1IsDisplay: false,
          // 社員番号
          synoIsDisplay: false,
          // メールアドレス
          emailIsDisplay: false,
          // ＤＭ・メルマガ
          dmkbIsDisplay: false,
          // 備考
          mem1IsDisplay: false,
				},
        // モーダルウィンドウ
        modal: {
					// システムエラー
					systemError: {
            messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
            isShow: false
          },
        }
      }
    },
    // フィルター
    filters: {
      // 金額表示用三桁ごとにカンマをつける
      moneyDelimiter: function(value) {

        if(value == null) {
          return ''
        }
        
        return value.toLocaleString()
      }
    },
		// ライフサイクルフック: created
    created: function () {
      UtilityConsoleLog.consoleLog('CommonReserveDetail::created Start')

      this.firstDisplay()

      UtilityConsoleLog.consoleLog('CommonReserveDetail::created End')
    },
    methods: {
      // 表示系--------------------------------------------------S
      // 初期表示
			firstDisplay: function () {
				UtilityConsoleLog.consoleLog('CommonReserveDetail::firstDisplay Start')

				// 初期値を取得する
        CommonReserveDetail.FirstDisplay({
          token: this.$store.state.auth.token,
          ircd: this.$store.state.auth.ircd,
          ukno: this.$store.state.commonUserInfo.myPage.detailUkno
        }).then(({ responce }) => {
					
          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

            this.detail.ukno = this.$store.state.commonUserInfo.myPage.detailUkno

						// クライアントコード
						var tempJgcd = ""

					  // レスポンスからデータ取得
            this.detail.taxk = responce.data.taxk
            this.detail.kshj = responce.data.kshj
						this.detail.reserveDateYear = responce.data.reserveDateYear
						this.detail.reserveDateMonth = responce.data.reserveDateMonth
						this.detail.reserveDateDate = responce.data.reserveDateDate
						this.detail.reserveSthm = responce.data.reserveSthm
						this.detail.courseInfo = responce.data.courseInfo
						this.detail.optionInfoList = responce.data.optionInfoList
            //this.detail.sumKngk = responce.data.sumKngk
            this.detail.sumGkgk = responce.data.sumGkgk
						tempJgcd = responce.data.jgcd
						this.detail.jgnm = responce.data.jgnm
						this.detail.hksh = responce.data.hksh
						this.detail.hkkg = responce.data.hkkg
						this.detail.hkno = responce.data.hkno
						this.detail.kbnm = responce.data.kbnm
						this.detail.cmnm = responce.data.cmnm
						this.detail.name = responce.data.name
						this.detail.ryak = responce.data.ryak
						this.detail.btdyYear = responce.data.btdyYear
						this.detail.btdyMonth = responce.data.btdyMonth
						this.detail.btdyDate = responce.data.btdyDate
						this.detail.age = responce.data.age
						this.detail.sex = responce.data.sex
						this.detail.zip = responce.data.zip
						this.detail.adr1 = responce.data.adr1
						this.detail.adr2 = responce.data.adr2
						this.detail.adr3 = responce.data.adr3
						this.detail.tel1 = responce.data.tel1
						this.detail.syno = responce.data.syno
						this.detail.email = responce.data.emal
						this.detail.dmkb = responce.data.dmkb
						this.detail.mem1 = responce.data.mem1

						// ユーザータイプを決める
        		this.userType = this.getUserType(
							tempJgcd
						)

						// ユーザータイプによってそれぞれ初期設定
        		// （表示非表示）を行う
        		this.setInitializeValue()
            
          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
            this.onSystemErrorModalOpen()
          }

        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('CommonReserveDetail::firstDisplay End')
	      })

			},
      // 表示系--------------------------------------------------E
      // ストア値などからユーザータイプを取得
      getUserType: function(in_jgcd){

        UtilityConsoleLog.consoleLog('CommonReserveDetail::getUserType Start')
      
      	var resultUserType = ''

      	// 個人か健保かどうか
      	if('00000000' == in_jgcd) {
      	  // 個人
      	  resultUserType = this.codeUserTypeMyPageChangeIndividual
      	} else {
      	  // 健保
      	  resultUserType = this.codeUserTypeMyPageChangeHealth
      	}

        UtilityConsoleLog.consoleLog('CommonReserveDetail::getUserType End')

      	return resultUserType
      },
			// ユーザータイプによって初期化関数を呼び出す
			setInitializeValue: function () {
        UtilityConsoleLog.consoleLog('CommonReserveDetail::setInitializeValue Start')

        if(this.codeUserTypeMyPageChangeIndividual == this.userType) {
          // 2: マイページ経由かつ予約変更（個人）
          this.setInitializeValueMyPageChangeIndividual()
        } else if(this.codeUserTypeMyPageChangeHealth == this.userType) {
          // 3: マイページ経由かつ予約変更（健保）
          this.setInitializeValueMyPageChangeHealth()
        }

        UtilityConsoleLog.consoleLog('CommonReserveDetail::setInitializeValue End')
			},
      // 2: マイページ経由かつ予約変更（個人）時の各項目初期化
      setInitializeValueMyPageChangeIndividual: function() {
        UtilityConsoleLog.consoleLog('CommonReserveDetail::setInitializeValueMyPageChangeIndividual Start')

        // 健康保険組合名
        this.detail.jgcdIsDisplay = true

        // 保険者番号
        this.detail.hkshIsDisplay = false

        // 保険証記号
        this.detail.hkkgIsDisplay = true

        // 保険証番号
        this.detail.hknoIsDisplay = true

        // 対象者区分
        this.detail.hfkbIsDisplay = true

        // 企業名
        this.detail.cmnmIsDisplay = true

        // 漢字氏名
        // 姓
        this.detail.nam1IsDisplay = true
        // 名
        this.detail.nam2IsDisplay = true

        // カナ氏名
        // 姓
        this.detail.ryk1IsDisplay = true
        // 名
        this.detail.ryk2IsDisplay = true

        // 生年月日
        // 年
        this.detail.btdyYearIsDisplay = true
        // 月
        this.detail.btdyMonthIsDisplay = true
        // 日
        this.detail.btdyDateIsDisplay = true

        // 年齢
        this.detail.ageIsDisplay = true

        // 性別
        this.detail.sexIsDisplay = true

        // ご住所
        // 郵便番号 前半
        this.detail.zip1IsDisplay = true
        // 郵便番号 後半
        this.detail.zip2IsDisplay = true
        // 都道府県
        this.detail.adr1IsDisplay = true
        // 住所１（市区町村）
        this.detail.adr2IsDisplay = true
        // 住所２（番地）
        this.detail.adr3IsDisplay = true

        // 電話番号
        this.detail.tel1IsDisplay = true

        // 社員番号
        this.detail.synoIsDisplay = true

        // メールアドレス
        this.detail.emailIsDisplay = true

        // ＤＭ・メルマガ
        this.detail.dmkbIsDisplay = true

        // 備考
        this.detail.mem1IsDisplay = true

        UtilityConsoleLog.consoleLog('CommonReserveDetail::setInitializeValueMyPageChangeIndividual End')
      },
      // 3: マイページ経由かつ予約変更（健保）時の各項目初期化
      setInitializeValueMyPageChangeHealth: function() {
        UtilityConsoleLog.consoleLog('CommonReserveDetail::setInitializeValueMyPageChangeHealth Start')

        // 健康保険組合名
        this.detail.jgcdIsDisplay = true

        // 保険者番号
        this.detail.hkshIsDisplay = true

        // 保険証記号
        this.detail.hkkgIsDisplay = true

        // 保険証番号
        this.detail.hknoIsDisplay = true

        // 対象者区分
        this.detail.hfkbIsDisplay = true

        // 企業名
        this.detail.cmnmIsDisplay = true

        // 漢字氏名
        // 姓
        this.detail.nam1IsDisplay = true
        // 名
        this.detail.nam2IsDisplay = true

        // カナ氏名
        // 姓
        this.detail.ryk1IsDisplay = true
        // 名
        this.detail.ryk2IsDisplay = true

        // 生年月日
        // 年
        this.detail.btdyYearIsDisplay = true
        // 月
        this.detail.btdyMonthIsDisplay = true
        // 日
        this.detail.btdyDateIsDisplay = true

        // 年齢
        this.detail.ageIsDisplay = true

        // 性別
        this.detail.sexIsDisplay = true

        // ご住所
        // 郵便番号 前半
        this.detail.zip1IsDisplay = true
        // 郵便番号 後半
        this.detail.zip2IsDisplay = true
        // 都道府県
        this.detail.adr1IsDisplay = true
        // 住所１（市区町村）
        this.detail.adr2IsDisplay = true
        // 住所２（番地）
        this.detail.adr3IsDisplay = true

        // 電話番号
        this.detail.tel1IsDisplay = true

        // 社員番号
        this.detail.synoIsDisplay = true

        // メールアドレス
        this.detail.emailIsDisplay = true

        // ＤＭ・メルマガ
        this.detail.dmkbIsDisplay = false

        // 備考
        this.detail.mem1IsDisplay = true

        UtilityConsoleLog.consoleLog('CommonReserveDetail::setInitializeValueMyPageChangeHealth End')
      },
			// 戻るボタン押下時
      onBack: function() {
        UtilityConsoleLog.consoleLog('CommonReserveDetail::onBack Start')

				// ストア値の変更
        this.$store.commit(
          types.COMMON_RESERVEDETAIL_BACK)

        // マイページに遷移
        this.$router.push("/CommonMyPage")

        UtilityConsoleLog.consoleLog('CommonReserveDetail::onBack End')
      },
      // システムエラーモーダルとしてエラーモーダルを開く
      onSystemErrorModalOpen: function () {

        UtilityConsoleLog.consoleLog('CommonReserveDetail::onSystemErrorModalOpen Start')

        this.modalOpen('systemError')

        UtilityConsoleLog.consoleLog('CommonReserveDetail::onSystemErrorModalOpen End')
      },
      // システムエラーモーダルを閉じる
      onSystemErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonReserveDetail::onSystemErrorModalClose Start')

        this.modalClose('systemError')

				// URLパラム
				var tempParam = this.$store.getters.getCommonParam

				// トップ画面へ遷移
				this.$router.push('/CommonTop/' + tempParam)

        UtilityConsoleLog.consoleLog('CommonReserveDetail::onSystemErrorModalClose End')
      },
      // モーダルウィンドウを開く
      modalOpen: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonReserveDetail::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

        this.modal[modalName].isShow = true

        UtilityConsoleLog.consoleLog('CommonConfirmCancel::modalOpen End')
      },
      // モーダルウィンドウを閉じる
      modalClose: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonReserveDetail::modalClose Start')

        this.modal[modalName].isShow = false

        UtilityConsoleLog.consoleLog('CommonReserveDetail::modalClose End')
      },
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			},
      // 検査項目の受診区分(1:全員 2:一部)によってCSSクラス名を返す
      // 1:全員の場合は背景色を黄色にする
      getBackendColorInspectionJskb: function (jskb) {

        var resultClassName = ''

        // 背景色を黄色にするクラス名を返す
        if ('1' == jskb) {
          resultClassName = 'courseListKensa1'
        } else {
          resultClassName = 'courseListKensa0'
        }

        return resultClassName;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/ReserveDetail/CommonReserveDetail.vue